import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./Career.css";

import group1img from "../../assests/Career/Group1.png";
import group2img from "../../assests/Career/Group2.png";
import group3img from "../../assests/Career/Group3.png";
import group4img from "../../assests/Career/Group4.svg";
import group5img from "../../assests/Career/Group5.svg";
import group6img from "../../assests/Career/Group6.svg";
import group7img from "../../assests/Career/Group7.svg";
import group8img from "../../assests/Career/Group8.svg";
import group9img from "../../assests/Career/Group9.svg";
import group10img from "../../assests/Career/Group10.svg";

const Career: React.FC = () => {
  const items = [
    {
      icon: group1img,
      title: "Career Growth",
      desc: "Clear paths for promotion, learning, and skill development.",
    },
    {
      icon: group4img,
      title: "Recognition & Rewards",
      desc: "Your efforts are celebrated and appreciated.",
    },
    {
      icon: group2img,
      title: "Collaborative Environment",
      desc: "Teamwork that values your voice and ideas.",
    },
    {
      icon: group5img,
      title: "Learning & Development",
      desc: "Ongoing training, mentorship, and workshops.",
    },
    {
      icon: group3img,
      title: "Work–Life Balance",
      desc: "Flexible schedules and a supportive work culture.",
    },
    {
      icon: group6img,
      title: "Innovation Focus",
      desc: "We encourage creativity and new ideas in every project.",
    },
    {
      icon: group7img,
      title: "Global Opportunities",
      desc: "Work with teams and clients from around the world.",
    },
    {
      icon: group8img,
      title: "Inclusive Culture",
      desc: "Diversity and inclusion are at the heart of our values.",
    },
    {
      icon: group9img,
      title: "Mentorship Programs",
      desc: "Grow under the guidance of industry experts.",
    },
    {
      icon: group10img,
      title: "Health & Wellness",
      desc: "We care about your physical and mental well-being.",
    },
  ];

  // Split items into chunks of 3
  const chunkedItems = [];
  for (let i = 0; i < items.length; i += 3) {
    chunkedItems.push(items.slice(i, i + 3));
  }

  return (
    <section id="career" className="career-section">
            <Container className="about-container text-center">
              <h3 className="career-heading"> <span className="dot"></span>Career</h3>
              <h1 className="carer-para">Unlock your potential at Xyloite</h1>
            </Container>
      <div  className="career-container">
        <Row className="justify-content-between">
          {/* Left Column */}
          <Col
            xs={12}
            md={6}
            lg={5}
            className="career-left text-md-start text-center"
          >
            <h2 className="career-title">Xyloite Career</h2>
            <p className="career-subtitle">
              “Build your future with us. Equal opportunities for all, every
              step of the way.”
            </p>
            <Button className="career-button">See Current Openings</Button>
          </Col>

          {/* Right Column - Vertical Carousel */}
          <Col sm={6} md={6} lg={5} className="career-right">
            <div className="vertical-carousel">
              <div className="carousel-track">
                {chunkedItems.map((group, idx) => (
                  <div className="carousel-slide my-2" key={idx}>
                    {group.map((item, i) => (
                      <div
                        className="career-card-small d-flex align-items-center"
                        key={i}
                      >
                        <img
                          src={item.icon}
                          alt={item.title}
                          className="career-icon-small"
                        />
                        <div>
                          <h6>{item.title}</h6>
                          <p>{item.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Career;
